import { i18n as _i18n } from "@lingui/core";
import React from 'react';
import { useLingui } from '@lingui/react';
import { BannerReturnCustomer, CarleadDataLayerManufacturerActive, useCarleadConfiguration } from '@wkda/carlead-creation-components';
import { ABExperimentSnippet, Layout } from '@wkda/funnel-components';
import { Helmet } from 'react-helmet';
import { CarleadCollapseButtonFaq, CarleadHowItWorks, CarleadTextButton, CarleadTopBlueCar, CarleadWhyChoose, getHappyCustomerSliderCarleadContent, getImageContent, HappyCustomerSlider, ImageContent } from '../../../../components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CarleadTopBlueCarHCSliderMap = _ref => {
  let {
    form,
    happyCustomerSettingsOverrides = '',
    className = '',
    howItWorksShowCta = false
  } = _ref;
  const {
    abExperiment
  } = useCarleadConfiguration();
  const mapContent = getImageContent().mapContent;
  const happyCustomerSliderSlimContent = getHappyCustomerSliderCarleadContent('happyCustomersSlim');
  const {
    i18n
  } = useLingui();
  return /*#__PURE__*/_jsxs(Layout, {
    customBanner: BannerReturnCustomer,
    containerClassName: "carlead-redesign carlead-redesign-blue " + className,
    modernLayout: true,
    children: [/*#__PURE__*/_jsx(Helmet, {
      children: /*#__PURE__*/_jsx("title", {
        children: i18n._('carlead.pageTitle')
      })
    }), /*#__PURE__*/_jsx(CarleadDataLayerManufacturerActive, {}), /*#__PURE__*/_jsx(ABExperimentSnippet, {
      experimentSnippetName: abExperiment.experimentSnippetName
    }), /*#__PURE__*/_jsxs("div", {
      "data-category": "Lead Page",
      children: [/*#__PURE__*/_jsx("div", {
        className: "box blue top-blue-car-box",
        children: /*#__PURE__*/_jsx(CarleadTopBlueCar, {})
      }), form, /*#__PURE__*/_jsx("div", {
        className: "box gap white",
        children: /*#__PURE__*/_jsx("div", {
          className: "container",
          children: /*#__PURE__*/_jsx(HappyCustomerSlider, {
            content: happyCustomerSliderSlimContent,
            overrides: happyCustomerSettingsOverrides
          })
        })
      }), /*#__PURE__*/_jsx(CarleadHowItWorks, {
        showCTA: howItWorksShowCta
      }), /*#__PURE__*/_jsx("div", {
        className: "box map-box white",
        "data-category": "Map",
        children: /*#__PURE__*/_jsx("div", {
          className: "container",
          children: /*#__PURE__*/_jsx(ImageContent, {
            className: mapContent.className,
            image: mapContent.image,
            imageColumn: mapContent.imageColumn,
            contentColumn: mapContent.contentColumn,
            cta: mapContent.cta,
            contentTitle: mapContent.contentTitle,
            contentSubtitle: mapContent.contentSubtitle
          })
        })
      }), /*#__PURE__*/_jsx(CarleadWhyChoose, {}), /*#__PURE__*/_jsx(CarleadCollapseButtonFaq, {}), /*#__PURE__*/_jsx(CarleadTextButton, {
        text: _i18n._(
        /*i18n*/
        {
          id: 'carlead.textButton.text'
        })
      })]
    })]
  });
};
export default CarleadTopBlueCarHCSliderMap;